module.exports = __webpack_public_path__ + "img/安阳市-c.9e26b35b.png";